module.exports = __webpack_public_path__ + "img/case-banner__list4.png?09237f5c973f3a9d791319fd5f5ef95d";